module.exports = __webpack_public_path__ + "img/SectionPurple.e674004a.png";